"use client"

import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Navbar from "../../components/account/Navbar" // Import Navbar
import Footer from "../../components/account/Footer" // Import Footer
import CreditCardModal from "../../components/modals/CreditCardModal"
import BankAccountModal from "../../components/modals/BankAccountModal"
import "./accountmanage.css"

// Import card images
import PurpleCreditCard from "/images/account/bank-card.png"
import RedBankAccount from "/images/account/bank-account.png"

// Financial Management Content Component (for use within AccountPreferences)
const FinancialManagementContent = () => {
  const [isCreditCardModalOpen, setIsCreditCardModalOpen] = useState(false)
  const [isBankAccountModalOpen, setIsBankAccountModalOpen] = useState(false)

  // We'll keep these states for potential future dynamic data,
  // but for now, the images are static.
  const [creditCards, setCreditCards] = useState([{ id: 1, type: "credit", image: PurpleCreditCard }])
  const [bankAccounts, setBankAccounts] = useState([{ id: 1, type: "bank", image: RedBankAccount }])

  const handleAddCreditCard = (cardData) => {
    // This function would typically add a new card to the state
    // For now, we're using static images, so this won't visually change anything
    setIsCreditCardModalOpen(false)
  }

  const handleAddBankAccount = (accountData) => {
    // This function would typically add a new bank account to the state
    // For now, we're using static images, so this won't visually change anything
    setIsBankAccountModalOpen(false)
  }

  const refreshBalance = () => {
    // Here you would implement the API call to refresh balance
  }

  return (
    <>
      <div className="financialmanagement-container">
        <main className="financialmanagement-main">
          {/* Current Balance Section */}
          <div className="financialmanagement-balance-header">
            <h2 className="financialmanagement-balance-title">
              Current Balance
            </h2>
            <button
              onClick={refreshBalance}
              className="financialmanagement-refresh-btn"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2">
                <path d="M23 4v6h-6" />
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
              </svg>
            </button>
          </div>

          {/* Balance Display */}
          <div className="financialmanagement-balance-display">
            <div className="financialmanagement-balance-amount">
              <span>$2,458.50</span>
              <span className="financialmanagement-balance-currency">
                USD
              </span>
            </div>
            <p className="financialmanagement-balance-updated">
              Last updated: Today, 2:30 PM
            </p>
          </div>

          {/* My Card Section */}
          <div className="financialmanagement-cards-header">
            <h2 className="financialmanagement-cards-title">
              My Card
            </h2>
            <button
              onClick={() => setIsCreditCardModalOpen(true)} // This button is for adding a new credit card
              className="financialmanagement-add-btn"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="16" />
                <line x1="8" y1="12" x2="16" y2="12" />
              </svg>
              Add new
            </button>
          </div>

          {/* Cards Grid */}
          <div className="financialmanagement-cards-grid">
            {/* Credit Cards Display */}
            {creditCards.map((card) => (
              <div key={card.id} className="financialmanagement-card-item">
                <img
                  src={card.image || "/placeholder.svg"}
                  alt="Credit Card"
                  className="financialmanagement-card-image"
                />
                <h3 className="financialmanagement-card-title">
                  Credit or Debit Card
                </h3>
              </div>
            ))}

            {/* Bank Accounts Display */}
            {bankAccounts.map((account) => (
              <div key={account.id} className="financialmanagement-card-item">
                <img
                  src={account.image || "/placeholder.svg"}
                  alt="Bank Account"
                  className="financialmanagement-card-image"
                />
                <h3 className="financialmanagement-card-title">
                  Bank Account
                </h3>
              </div>
            ))}

            {/* Add New Credit Card Button (Placeholder for adding new) */}
            <div
              onClick={() => setIsCreditCardModalOpen(true)}
              className="financialmanagement-add-card"
            >
              <div className="financialmanagement-add-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="16" />
                  <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
              </div>
              <div className="financialmanagement-add-title">
                Add Credit Card
              </div>
              <div className="financialmanagement-add-subtitle">
                Click to add a new credit card
              </div>
            </div>

            {/* Add New Bank Account Button (Placeholder for adding new) */}
            <div
              onClick={() => setIsBankAccountModalOpen(true)}
              className="financialmanagement-add-card"
            >
              <div className="financialmanagement-add-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="16" />
                  <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
              </div>
              <div className="financialmanagement-add-title">
                Add Bank Account
              </div>
              <div className="financialmanagement-add-subtitle">
                Click to add a new bank account
              </div>
            </div>
          </div>
        </main>

      </div>

      {/* Credit Card Modal */}
      <CreditCardModal
        isOpen={isCreditCardModalOpen}
        onClose={() => setIsCreditCardModalOpen(false)}
        onSave={handleAddCreditCard}
      />

      {/* Bank Account Modal */}
      <BankAccountModal
        isOpen={isBankAccountModalOpen}
        onClose={() => setIsBankAccountModalOpen(false)}
        onSave={handleAddBankAccount}
      />
    </>
  )
}

// Wrapper component for backward compatibility
const FinancialManagement = () => {
  const navigate = useNavigate()
  const { userType } = useParams()
  
  return (
    <div className="financialmanagement-page">
      <Navbar userType={userType} />
      <FinancialManagementContent />
    </div>
  )
}

export default FinancialManagement
export { FinancialManagementContent }
